import { useState, useEffect } from 'react';

export default function FixedContactButtons() {
  const [isVisible, setIsVisible] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* ポップアップオーバーレイ */}
      {isPopupOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 transition-opacity"
          onClick={() => setIsPopupOpen(false)}
        />
      )}

      {/* ポップアップメニュー */}
      {isPopupOpen && (
        <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden animate-[slideUp_0.3s_ease-out]">
          <button
            onClick={() => setIsPopupOpen(false)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer z-10"
          >
            <i className="ri-close-line text-2xl w-6 h-6 flex items-center justify-center"></i>
          </button>

          {/* 受付スタッフ画像 */}
          <div className="relative h-32 bg-gradient-to-br from-pink-50 to-pink-100">
            <img
              src="https://public.readdy.ai/ai/img_res/58f3f6ddd108b0016660b8741a0884f8.jpg"
              alt="受付スタッフ"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>
          </div>

          <div className="p-6 pt-2">
            <h3 className="text-xl font-bold text-gray-800 mb-2 text-center">
              お問い合わせ方法を選択
            </h3>
            <p className="text-sm text-gray-600 mb-6 text-center">
              お気軽にご相談ください
            </p>

            <div className="space-y-4">
              <a 
                href="tel:0120-196-247"
                className="flex items-center gap-4 bg-pink-500 hover:bg-pink-600 text-white px-6 py-5 rounded-xl font-bold transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                <div className="bg-white/20 w-14 h-14 rounded-full flex items-center justify-center">
                  <i className="ri-phone-fill text-3xl w-8 h-8 flex items-center justify-center"></i>
                </div>
                <div className="text-left flex-1">
                  <div className="text-sm opacity-90">電話で相談</div>
                  <div className="text-xl leading-tight">0120-196-247</div>
                </div>
              </a>

              <a 
                href="https://line.me/ti/p/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-green-500 hover:bg-green-600 text-white px-6 py-5 rounded-xl font-bold transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                <div className="bg-white/20 w-14 h-14 rounded-full flex items-center justify-center">
                  <i className="ri-line-fill text-3xl w-8 h-8 flex items-center justify-center"></i>
                </div>
                <div className="text-left flex-1">
                  <div className="text-sm opacity-90">LINEで相談</div>
                  <div className="text-xl leading-tight">24時間受付</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}

      {/* 固定ボタン */}
      <div 
        className={`fixed bottom-0 left-0 right-0 z-50 bg-white shadow-2xl border-t-2 border-gray-200 transition-transform duration-500 ${
          isVisible ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 py-3">
          <button
            onClick={() => setIsPopupOpen(true)}
            className="w-full flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white px-6 py-4 rounded-lg font-bold transition-colors cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-customer-service-2-fill text-2xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-lg">お問い合わせはこちらから</span>
            <i className="ri-arrow-up-s-line text-2xl w-6 h-6 flex items-center justify-center"></i>
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translate(-50%, 20px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
      `}</style>
    </>
  );
}
